import { gql } from "@apollo/client";

export const GET_AUTH_BY_DEVICE_QUERY = gql`
  query GET_AUTH_BY_DEVICE_QUERY {
    getAuthByDevice {
      token
    }
  }
`;
